import React, { useEffect, useRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { showToast } from '../helper/notifications'; // UPDATED IMPORT
import { useAuth } from '../context/AuthContext';
import '../custom.css';

const GOOGLE_CLIENT_ID =
  process.env.REACT_APP_GOOGLE_CLIENT_ID ||
  '729426578542-sg42kq5upddujur3ce911lh847pj1mdv.apps.googleusercontent.com';

const SignInPage = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const signInDivRef = useRef(null);
  const initializedRef = useRef(false);

  const handleCallbackResponse = useCallback(
    async (response) => {
      if (!response?.credential) {
        // UPDATED: Use showToast for error
        showToast('error', 'Google Sign-In failed.');
        return;
      }

      try {
        const result = await login(response.credential);
        const isSuccess = result === true || (result && result.success === true);
        if (isSuccess) {
          showToast('success', 'Welcome back!');
          navigate("/locations-top");
        } else {
          const errMsg = (result && result.message) ? result.message : 'Sign-In failed. Please verify the backend server is running and your email is registered.';
          showToast('error', errMsg);
        }
      } catch (error) {
        console.error('Sign-in error:', error);
        showToast('error', error.message || 'An unexpected error occurred during sign-in.');
      }
    },
    [login, navigate]
  );

  useEffect(() => {
    let attempts = 0;
    const maxAttempts = 10;

    const renderButton = () => {
      if (initializedRef.current) return;

      if (!window.google || !signInDivRef.current) {
        if (attempts++ < maxAttempts) {
          setTimeout(renderButton, 250);
        } else {
          // UPDATED: Use showToast for error
          showToast('error', 'Google Sign-In failed to load.');
        }
        return;
      }

      const { width } = signInDivRef.current.getBoundingClientRect();
      if (width === 0) {
        requestAnimationFrame(renderButton);
        return;
      }

      try {
        window.google.accounts.id.initialize({
          client_id: GOOGLE_CLIENT_ID,
          callback: handleCallbackResponse,
        });

        window.google.accounts.id.renderButton(signInDivRef.current, {
          theme: 'outline',
          size: 'large',
          width: width, 
          text: 'signin_with',
          shape: 'rectangular',
        });

        initializedRef.current = true;
      } catch (error) {
        console.error('Google Sign-In render error:', error);
      }
    };

    renderButton();
  }, [handleCallbackResponse]);

  return (
    <div
      className="signin-page-wrapper qiu-signin-bg"
      style={{
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '1.5rem'
      }}
    >
      <div 
        className="card qiu-signin-card" 
        style={{ width: '100%', maxWidth: '420px' }}
      >
        <div className="card-body p-40 text-center">
          <div className="mb-32 d-flex justify-content-center">
            <img
              src="/assets/images/logo-start.png"
              alt="QIU | AI Logo"
              className="img-fluid"
              style={{ maxHeight: '72px', width: 'auto', objectFit: 'contain' }}
            />
          </div>

          <p className="qiu-signin-subtitle mb-24">Please log in with your Google Account</p>

          <div className="d-flex justify-content-center mb-28" style={{ minHeight: '44px' }}>
            <div
              ref={signInDivRef}
              style={{ width: '100%' }} 
            />
          </div>

          <div className="qiu-signin-footer pt-20 mt-12">
            <small className="d-block">
              &copy; 2026 Qiu AI GmbH
            </small>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignInPage;